import { TAGLink } from '@aspendental/shared-components-web';
import LanguageToggle from '@aspendental/shared-components-web/lib/components/LanguageToggle';
import { AnalyticsContext, NavigationLink } from '@aspendental/shared-components-web/lib/graphql/__generated/sdk';
import PhoneIcon from '@mui/icons-material/Phone';
import { Box, Typography } from '@mui/material';
export const CLEAR_CHOICE_LOGO_DARK = 'https://images.ctfassets.net/m8zwsu9tyucg/5x1c5PNK9hR8cNJUwEDas9/8ba5b1b871d95fae9627d93268693828/Color_Primary.svg';
const menuIconStyles = {
  fontSize: 20,
  verticalAlign: 'middle',
  minWidth: 24,
  color: '#0A2F54'
};
interface ScheduleMobileHeaderProps {
  logoHref: string;
  appData: any;
  languageToggleEnabled: boolean;
  determinePhoneNumber: (phoneNumberNavItem: NavigationLink | undefined, phoneNumber: any) => string;
  withFixedHeader?: boolean;
}
const ScheduleMobileHeader = ({
  logoHref,
  appData,
  languageToggleEnabled,
  determinePhoneNumber,
  withFixedHeader
}: ScheduleMobileHeaderProps) => {
  const rawNumber = determinePhoneNumber(undefined, appData?.header?.phoneNumber) || '888-486-3443';
  const telNumber = `+1${rawNumber.replace(/\D/g, '')}`;
  return <Box sx={{
    display: 'flex',
    alignItems: 'center',
    minHeight: '4rem',
    px: 2,
    background: '#fff',
    width: '100%',
    position: withFixedHeader ? 'fixed' : 'static',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1200,
    boxShadow: 1
  }} data-test-id="section_header" data-sentry-element="Box" data-sentry-component="ScheduleMobileHeader" data-sentry-source-file="ScheduleMobileHeader.tsx">
			{/* Logo (left) */}
			<Box sx={{
      flex: '0 0 auto',
      mr: 2
    }} data-sentry-element="Box" data-sentry-source-file="ScheduleMobileHeader.tsx">
				<TAGLink href={logoHref} data-test-id="link_logo" data-sentry-element="TAGLink" data-sentry-source-file="ScheduleMobileHeader.tsx">
					<Box component="img" src={CLEAR_CHOICE_LOGO_DARK} alt="ClearChoice Logo" sx={{
          height: 32,
          width: 'auto'
        }} data-sentry-element="Box" data-sentry-source-file="ScheduleMobileHeader.tsx" />
				</TAGLink>
			</Box>
			{/* Phone number (center) */}
			<Box sx={{
      flex: 1,
      display: 'flex',
      alignContent: 'center',
      justifyContent: 'flex-end',
      minWidth: 0,
      '.InvocaNumber': {
        display: 'flex',
        alignItems: 'center',
        '@media (max-width:365px)': {
          '& .MuiTypography-root[data-test-id="text_phone_link_mobile"]': {
            fontSize: 14
          },
          '& .MuiSvgIcon-root': {
            fontSize: 14,
            minWidth: 0
          }
        }
      }
    }} data-sentry-element="Box" data-sentry-source-file="ScheduleMobileHeader.tsx">
				{rawNumber ? <TAGLink noLinkStyle href={`tel:${telNumber}`} analyticsContext={{
        clickPosition: 'header'
      } as AnalyticsContext}>
						<PhoneIcon sx={menuIconStyles} />
						<Typography variant="bodyMediumBold" fontWeight={400} color="#075E86" data-test-id="text_phone_link_mobile" sx={{
          ml: 0.5,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}>
							{rawNumber}
						</Typography>
					</TAGLink> : null}
				{languageToggleEnabled && <Box sx={{
        flex: '0 0 auto',
        ml: 0
      }}>
						<LanguageToggle isLargeDevice={false} />
					</Box>}
			</Box>
		</Box>;
};
export default ScheduleMobileHeader;